module.exports = "/images/vendor/vue-paycard/src/17.jpg?c3609e51ecd7014cd40ec2f9ce937764";